import axios from "axios";
import {
  STOCK_URL,
  WAREHOUSE_URL,
  STOCK_ACTIVITY_LOGS,
  CHANNEL_URL,
  CHANNELS_STOCK_REPORT,
  PRESIGNED_URL,
  STOCKS_BULK_EDIT_URL,
  STOCK_ACTIVITY_EXPORT,
} from "../../../../../constants/config";
import { checkBackgroundTaskStatus } from "../../../Common/backgroundTaskStatus";

export function findStocks(queryParams) {
  const sortField = queryParams?.sortBy || queryParams?.sortField || "id";
  const sortOrder = queryParams?.sortOrder === "desc" ? "desc" : "asc";
  const sortBy = queryParams?.sort_by || `${sortField}:${sortOrder}`;
  return axios.get(
    `${STOCK_URL}/list?search_key=${queryParams.searchKey ? queryParams.searchKey : ""}&page=${
      queryParams.pageNumber || ""
    }&page_size=${queryParams.pageSize}&product_ids=${queryParams?.product_ids || ""}&channel_ids=${queryParams.channelIds || ""}&brand_ids=${queryParams.brandIds || ""}&supplier_ids=${queryParams.supplierIds || ""}&category_ids=${queryParams.categoryIds || ""}&zone=${
      queryParams?.searchZone || ""
    }&aisle=${queryParams?.searchAisle || ""}&bin=${queryParams?.searchBin || ""}&location_ids=${queryParams?.locationIds || ""}&quantity_filter=${queryParams?.quantityLowHigh || ""}&has_damaged=${queryParams?.damagedProduct || ""}&out_of_stock=${queryParams?.outOfStock ? 1 : ""}&product_status=${queryParams?.product_status || ""}&sort_by=${sortBy}` // as we are setting sigle field for both out of stock and damaged that's why i am doing this
  );
}

export function searchStocks(queryParams, channelId) {
  // channelId scopes the hits to one warehouse's stock rows (Stock Locations page).
  const channel = channelId ? `&channel_ids=${Number(channelId)}` : "";
  return axios.get(`${STOCK_URL}/list?search_key=${queryParams}${channel}`);
}
export function searchStockById(queryParams) {
  return axios.get(`${STOCK_URL}/get?product_id=${queryParams}`);
}

export function updateStocks(payload) {
  return axios.post(`${STOCK_URL}/update`, { ...payload });
}

export function writeOffStock(payload) {
  return axios.post(`${STOCK_URL}/write-off`, { ...payload });
}

export function stocksBulkEdit(payload) {
  return axios.post(STOCKS_BULK_EDIT_URL, payload);
}

export function channelStockReport(payload) {
  return axios.post(`${CHANNELS_STOCK_REPORT}`, payload);
}

export function searchWarehouse(queryParams) {
  return axios.get(`${WAREHOUSE_URL}/list?search_key=${queryParams}`);
}
//Upload .Xlsx .csv file Data
export function thresholdBulkCreate(stockData) {
  return axios.patch(`${STOCK_URL}/threshold/bulk`, stockData);
}
export function stockBulkCreate(s3_key) {
  return axios.post(`${STOCK_URL}/import`, { s3_key });
}

export function findStockByName(queryParams) {
  console.log(queryParams);
  return axios.get(`${STOCK_URL}/list?nameSearchKey=${queryParams}`);
}

export function getChannels(params) {
  return axios.get(`${CHANNEL_URL}/list`, { params });
}

export function getChannelsById(id) {
  return axios.get(`${CHANNEL_URL}/${id}`);
}

export function findStockById(id, queryParams) {
  queryParams.page = queryParams.pageNumber;
  delete queryParams.pageNumber;
  return axios.get(`${STOCK_URL}/threshold/${id}`, { params: queryParams });
}

export function findStockByProductId(id) {
  return axios.get(`${STOCK_URL}/get?product_id=${id}`);
}

export function UpdateThreshold(productId, threshold) {
  return axios.patch(`${STOCK_URL}/threshold/${productId}`, {
    ...threshold,
  });
}

export function getPresignedUrl(key) {
  key = key.replaceAll(" ", "-");
  return axios.post(PRESIGNED_URL, [{ key: key }]);
}

export function uploadFileToCloud(payload) {
  return fetch(payload.url, {
    method: "PUT",
    body: payload.file,
  });
}

export function fetchStocksActivityLog(productId, params) {
  return axios.get(`${STOCK_ACTIVITY_LOGS}/${productId}`, {
    params,
  });
}

export function checkExportApiStatus(params) {
  return axios.post(
    `${STOCK_ACTIVITY_EXPORT}?search_key=${params.search_key}&product_id=${params?.product_id}&start_date=${params?.start_date}&end_date=${params?.end_date}&channel_ids=${params?.channel_ids}`
  );
}

export function getBackgroundJobs(id) {
  return checkBackgroundTaskStatus(id);
}
